import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../lib/scraper.slice";

type MaskProps = {
    text: string;
}

export function Mask({ text }: MaskProps) {
    const user = useSelector(selectUser);
    const is_admin = useMemo(() => user?.role === "admin", [user]);
    const masked_text = useMemo(() => { return "•".repeat(text.length); }, [text]);
    const [show_text, setShowText] = useState(false);

    return is_admin ?
        <span className="cursor-pointer" onClick={() => setShowText(!show_text)}>{show_text ? text : masked_text}</span> :
        <span>{masked_text}</span>;
}